export default {
  slug: "datalore",
  code: "DL",
  label: "Datalore",
  hasGrid: true,
  krakenDir: "Datalore",
  thumbnailColor: "#FCF84A",
  logoFamily: "data",
};
